import React from "react";

export default function RoutePending({ label = "Opening page" }) {
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[10000] h-0.5 bg-[#3578D8]" role="status" aria-label={label}>
      <span className="sr-only">{label}</span>
    </div>
  );
}
